import { render, staticRenderFns } from "./CategoriasProcessAdmin.vue?vue&type=template&id=7ce522eb&scoped=true&"
import script from "./CategoriasProcessAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoriasProcessAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasProcessAdmin.vue?vue&type=style&index=0&id=7ce522eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce522eb",
  null
  
)

export default component.exports